import React from "react";
import {Checkbox} from "primereact/checkbox";
import {Tag} from "primereact/tag";
import {bootstrapColors} from "../../../processes_documentation/static/static";

const ColorSelector = ({selectedColor, setSelectedColor}) => (
	<div className="col-3">
		<div className="col-12 p-0 mb-1 text-secondary">Choose the icon color</div>
		<div className="row p-0 m-0">
			{bootstrapColors.map(item => (
				<div key={item.color} className="col p-0 d-flex">
					<Checkbox
						inputId={item.color}
						className="d-none"
						name="color"
						value={item.color}
						checked={selectedColor === item.color}
						onChange={e => setSelectedColor(e.value)}
					/>
					<label
						htmlFor={item.color}
						className={
							selectedColor === item.color
								? "opacity-1 b-radius b-shadow ms-0 my-2 me-2"
								: "opacity-50 b-radius ms-0 my-2 me-2"
						}
						style={{width: "40px", height: "40px", cursor: "pointer"}}>
						<div className="position-relative">
							{selectedColor === item.color ? (
								<div className="position-absolute d-flex justify-content-center align-items-center">
									<Tag
										className={`bg-${item.color} font-bold b-radius `}
										style={{width: "40px", height: "40px"}}
									/>
									<i className="pi pi-check text-white position-absolute"></i>
								</div>
							) : (
								<Tag
									className={`bg-${item.color} font-bold b-radius `}
									style={{width: "40px", height: "40px"}}
								/>
							)}
						</div>
					</label>
				</div>
			))}
		</div>
	</div>
);

export default ColorSelector;
